import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Application, ApplicationBase } from '../../model/application/application-link.model';
import { ApplicationLinkType } from '../../model/application/application-link-type.model';
import { ApplicationOpenType } from '../../model/application/application-open-type.model';

interface HomeLinkResponse {
	code: string
	name: string
	url: string
	position: number
	linkType: number
	openMode: number
}

@Injectable({
	providedIn: 'root'
})
export class HomeLinkService {

	protected resourceUrl: string = '/rest/application-link'

	constructor(private http: HttpClient) { }

	getHomeLinks(): Observable<ApplicationBase[]> {
		return this.http.get<HomeLinkResponse[]>(`${this.resourceUrl}/home`).pipe(
			map(list => (list ?? []).map(link => this.toApplicationBase(link)))
		)
	}

	private toApplicationBase(link: HomeLinkResponse): ApplicationBase {
		const source = {
			code: link.code,
			name: link.name,
			url: link.url,
			visualOrder: link.position,
			type: link.linkType as ApplicationLinkType,
			openMode: link.openMode as ApplicationOpenType
		} as Application

		return ApplicationBase.from(source)
	}

}
